export default {
  methods: {
    timeout (ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixin/timeout.js